import firebase from "firebase/app"

export class FirebaseApp {

    static initialize () {
        // PRODUCTION
        const environment = 'vc21267';
        let config;

        if (environment === 'dev') {
            // STAGING
            config = {
                apiKey: "AIzaSyBAWa1AhN_a68SiLZR9P68oYsOuoP0ziDQ",
                authDomain: "stylight-staging.firebaseapp.com",
                databaseURL: "https://stylight-staging.firebaseio.com",
                projectId: "stylight-staging",
                storageBucket: "stylight-staging.appspot.com",
                messagingSenderId: "439301267072"
            };
        } else {
            // PRODUCTION
            config = {
                apiKey: "AIzaSyAKB_pAD6DiO5Uu3WkwhGwHOy2wgVpMcvk",
                authDomain: "stylight-532d4.firebaseapp.com",
                databaseURL: "https://stylight-532d4.firebaseio.com",
                projectId: "stylight-532d4",
                storageBucket: "stylight-532d4.appspot.com",
                messagingSenderId: "361542297647"
            };
        }

        firebase.initializeApp(config);
    }
}
